import {
  Factory,
  Flame,
  Layers,
  Scissors,
  Disc3,
  Drill,
  CircleDot,
  Cog,
  Wrench,
  Sparkles,
  Package,
  Ruler,
} from "lucide-react";
import Reveal, { SectionHeading } from "../components/Reveal";
import { MACHINERY } from "../data";

const ICONS = {
  factory: Factory,
  flame: Flame,
  layers: Layers,
  scissors: Scissors,
  disc: Disc3,
  drill: Drill,
  tap: CircleDot,
  mill: Cog,
  wrench: Wrench,
  sparkles: Sparkles,
  package: Package,
  ruler: Ruler,
};

export default function Machinery() {
  return (
    <section id="machinery" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <SectionHeading eyebrow="Machinery & Production Capabilities" title={<>The setup behind every casting</>} />
          <Reveal delay={0.15}>
            <p className="mt-6 text-stone-600 leading-relaxed">
              Our manufacturing setup includes machinery and equipment for every stage of component
              production — enabling us to handle component development, precision machining and
              production requirements, depending on component size, design and customer
              specifications.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-stone-200 border border-stone-200 rounded-2xl shadow-[0_20px_60px_rgba(20,23,28,0.05)] overflow-hidden" data-testid="machinery-bento">
          {MACHINERY.map((m, i) => {
            const Icon = ICONS[m.icon] || Cog;
            if (m.featured) {
              return (
                <Reveal
                  key={m.title}
                  delay={0.05 * i}
                  className="sm:col-span-2 lg:row-span-2 bg-[#14171C] p-8 lg:p-10 flex flex-col justify-between min-h-[260px]"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500/10 border border-amber-500/40 text-amber-400">
                    <Icon size={24} />
                  </span>
                  <div className="mt-8">
                    <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-amber-400">Core capability</p>
                    <h3 className="mt-2 font-display text-2xl lg:text-3xl font-bold uppercase leading-tight text-slate-100">
                      {m.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-400">
                      Molten aluminium injected into dies under controlled pressure and speed — the
                      core of our production floor.
                    </p>
                  </div>
                </Reveal>
              );
            }
            return (
              <Reveal
                key={m.title}
                delay={0.05 * i}
                className={`group bg-white hover:bg-[#FBF7EE] transition-colors p-6 flex items-center gap-4 ${m.wide ? "sm:col-span-2 lg:col-span-2" : ""}`}
              >
                <span className="shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-stone-300 text-stone-500 group-hover:border-amber-500 group-hover:text-amber-700 transition-colors">
                  <Icon size={18} />
                </span>
                <p className="text-sm sm:text-[15px] font-medium text-stone-800 leading-snug">{m.title}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
